import React, { useState } from 'react';

// 材料对比数据
const materialData = [
  {
    id: 'amethyst',
    name: '紫水晶',
    hardness: 7,
    priceRange: '¥10-50/克',
    suitableFor: [
      '日常佩戴',
      '冥想',
      '提升灵性'
    ],
    image: 'https://via.placeholder.com/400x300/9c27b0/ffffff?text=紫水晶'
  },
  {
    id: 'rose-quartz',
    name: '玫瑰石英',
    hardness: 7,
    priceRange: '¥5-30/克',
    suitableFor: [
      '日常佩戴',
      '提升爱情运势',
      '舒缓情绪'
    ],
    image: 'https://via.placeholder.com/400x300/e91e63/ffffff?text=玫瑰石英'
  },
  {
    id: 'citrine',
    name: '黄水晶',
    hardness: 7,
    priceRange: '¥15-60/克',
    suitableFor: [
      '日常佩戴',
      '提升财运',
      '增强自信'
    ],
    image: 'https://via.placeholder.com/400x300/ffc107/ffffff?text=黄水晶'
  },
  {
    id: 'obsidian',
    name: '黑曜石',
    hardness: 5-5.5,
    priceRange: '¥2-15/克',
    suitableFor: [
      '日常佩戴',
      '辟邪',
      '消除负能量'
    ],
    image: 'https://via.placeholder.com/400x300/212121/ffffff?text=黑曜石'
  },
  {
    id: 'clear-quartz',
    name: '白水晶',
    hardness: 7,
    priceRange: '¥3-20/克',
    suitableFor: [
      '日常佩戴',
      '净化能量',
      '增强其他水晶能量'
    ],
    image: 'https://via.placeholder.com/400x300/bdbdbd/ffffff?text=白水晶'
  }
];

const MaterialComparison = () => {
  const [sortBy, setSortBy] = useState('hardness');
  const [sortedMaterials, setSortedMaterials] = useState(materialData);

  // 排序材料
  const sortMaterials = (field) => {
    const sorted = [...materialData].sort((a, b) => {
      if (field === 'hardness') {
        return a.hardness - b.hardness;
      } else if (field === 'priceRange') {
        // 简单的价格范围排序
        const aPrice = parseInt(a.priceRange.match(/\d+/)[0]);
        const bPrice = parseInt(b.priceRange.match(/\d+/)[0]);
        return aPrice - bPrice;
      }
      return 0;
    });
    setSortedMaterials(sorted);
    setSortBy(field);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-8 text-indigo-800">
          手链材料对比表
        </h1>
        
        {/* 排序选项 */}
        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 mb-8 border border-purple-100">
          <div className="flex flex-wrap items-center gap-4">
            <span className="text-gray-700">排序方式：</span>
            <button
              onClick={() => sortMaterials('hardness')}
              className={`px-4 py-2 rounded-lg transition-colors duration-200 ${
                sortBy === 'hardness'
                  ? 'bg-purple-100 text-purple-800 font-medium'
                  : 'bg-gray-50 text-gray-700 hover:bg-purple-50'
              }`}
            >
              硬度
            </button>
            <button
              onClick={() => sortMaterials('priceRange')}
              className={`px-4 py-2 rounded-lg transition-colors duration-200 ${
                sortBy === 'priceRange'
                  ? 'bg-purple-100 text-purple-800 font-medium'
                  : 'bg-gray-50 text-gray-700 hover:bg-purple-50'
              }`}
            >
              价格
            </button>
          </div>
        </div>

        {/* 材料对比表 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {sortedMaterials.map((material) => (
            <div key={material.id} className="bg-white rounded-xl shadow-lg overflow-hidden border border-purple-100">
              {/* 材料图片 */}
              <div className="h-48 overflow-hidden">
                <img
                  src={material.image}
                  alt={material.name}
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                />
              </div>
              
              {/* 材料信息 */}
              <div className="p-6">
                <h2 className="text-xl font-semibold mb-2 text-indigo-700">
                  {material.name}
                </h2>
                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div className="bg-purple-50 rounded-lg p-3">
                    <div className="text-xs text-gray-600">硬度</div>
                    <div className="text-lg font-medium text-indigo-800">{material.hardness}</div>
                  </div>
                  <div className="bg-purple-50 rounded-lg p-3">
                    <div className="text-xs text-gray-600">价格区间</div>
                    <div className="text-lg font-medium text-indigo-800">{material.priceRange}</div>
                  </div>
                </div>
                <div>
                  <div className="text-sm font-semibold text-indigo-700 mb-2">适合场景：</div>
                  <ul className="space-y-1">
                    {material.suitableFor.map((item, index) => (
                      <li key={index} className="flex items-center gap-2">
                        <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                        <span className="text-gray-600">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MaterialComparison;